import React from 'react'
import Popup from '../../../components/Popup'
import './ReportNow.scss'

interface ReportNowConfig {
  title?: string
  reportContent?: string
  emailId?: string
  showButton1?: boolean
  button1Text?: string
  button1BgColor?: string
  button1TextColor?: string
  showButton2?: boolean
  button2Text?: string
  button2BgColor?: string
  button2TextColor?: string
}

interface ReportNowProps {
  isVisible: boolean
  onClose: () => void
  config: ReportNowConfig
  languageConfig?: any
  sessionId?: string
  productInfo?: any
  posthogEvent?: any
}

const ReportNow: React.FC<ReportNowProps> = ({
  isVisible,
  onClose,
  config,
  languageConfig = {},
  sessionId = '',
  productInfo = {},
  posthogEvent,
}) => {
  const getProcessedContent = (): string[] => {
    if (!config?.reportContent) return ['']

    try {
      let processedContent = config?.reportContent
      if (config?.emailId) {
        processedContent = processedContent?.replace(/<emailId>/g, config?.emailId)
      }

      const lines = processedContent
        ?.split('/n')
        .map((line) => line.trim())
        .filter((line) => line.length > 0)

      return lines?.length > 0 ? lines : ['']
    } catch (error) {
      console.error('Error processing report content:', error)
      return ['']
    }
  }

  const handleCopyEmail = async () => {
    if (config.emailId) {
      try {
        await navigator.clipboard?.writeText(config?.emailId)

        if (posthogEvent) {
          posthogEvent.sendPostHogEvent('email_copied', {
            sessionId,
            emailId: config.emailId,
            timestamp: new Date().toISOString(),
          })
        }

        console.log('Email copied to clipboard')
      } catch (error) {
        console.error('Failed to copy email:', error)

        try {
          const textArea = document.createElement('textarea')
          textArea.value = config.emailId
          document.body.appendChild(textArea)
          textArea.select()
          document.execCommand('copy')
          document.body.removeChild(textArea)
          console.log('Email copied using fallback method')
        } catch (fallbackError) {
          console.error('Fallback copy method also failed:', fallbackError)
        }
      }
    }
  }

  const handleClose = () => {
    if (posthogEvent) {
      posthogEvent.sendPostHogEvent('report_popup_closed', {
        sessionId,
        timestamp: new Date().toISOString(),
      })
    }
    onClose()
  }

  const processedContentLines = getProcessedContent()

  return (
    <Popup
      isVisible={isVisible}
      onClose={handleClose}
      className='report-now-popup'
      showCloseButton={false}
      maxWidth='100vw'
      maxHeight='70vh'
      showFooter={true}
      showButton1={config?.showButton1}
      button1Config={
        config?.showButton1
          ? {
              text: config?.button1Text || 'Copy Email ID',
              bgColor: config?.button1BgColor || '#3c3c3c',
              textColor: config?.button1TextColor || '#ffffff',
              onClick: handleCopyEmail,
            }
          : undefined
      }
      showButton2={config?.showButton2}
      button2Config={
        config?.showButton2
          ? {
              text: config?.button2Text || 'Close Window',
              bgColor: config?.button2BgColor || 'transparent',
              textColor: config?.button2TextColor || '#666666',
              onClick: handleClose,
            }
          : undefined
      }
    >
      <div className='report-now-popup__content'>
        <h2 className='report-now-popup__title'>{config?.title || 'Report Fake Product'}</h2>

        <div className='report-now-popup__message'>
          {processedContentLines && processedContentLines?.length > 0 ? (
            processedContentLines.map((line, index) => (
              <p key={index} className='report-now-popup__text'>
                {line}
              </p>
            ))
          ) : (
            <p className='report-now-popup__text'>No content available</p>
          )}
        </div>
      </div>
    </Popup>
  )
}

export default ReportNow
